import React from "react";
import LeaveOpereations from "./LeaveOpereations";

const LeaveActions = (params) => {
    return <LeaveOpereations params={params} />;
};

export default LeaveActions;
